<script setup>
import FooterLogo from '@/components/layout/Footer/FooterLogo.vue';
import FooterMain from '@/components/layout/Footer/FooterMain.vue';
import FooterBottom from '@/components/layout/Footer/FooterBottom.vue';
defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  socials: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <footer class="footer bg-black white">
    <div class="container">
      <div class="footer__wrap">
        <FooterLogo :logo="data?.logo" />
        <FooterMain
          :nav="data?.nav"
          :socials="socials"
          :additional-links="data?.additional_links"
          :contacts="data?.contacts"
        />
        <FooterBottom
          :copyright="data?.bottom?.copyright"
          :privacy="data?.bottom?.privacy"
          :developed-by="data?.bottom?.developed_by"
          :designed-by="data?.bottom?.designed_by"
        />
      </div>
    </div>
  </footer>
</template>
<style scoped lang="scss">
.footer {
  padding: 40px 0;
  @include media-breakpoint-up(sm) {
    padding: 64px 0;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(padding-top, 56);
    @include responsive-spacing(padding-bottom, 56);
  }
  &__wrap {
    display: flex;
    flex-direction: column;
    gap: 40px;
    @include media-breakpoint-up(sm) {
      gap: 64px;
    }
    @include media-breakpoint-up(md) {
      gap: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 56);
    }
  }
}
</style>
